<template>
  <button class="Btn-Close" :class="`Btn-Close--${props.type}`">
    <svg id="clear" viewBox="0 0 16 16">
      <path d="M3.61289944,2.20970461 L3.70710678,2.29289322 L8,6.585 L12.2928932,2.29289322 C12.6834175,1.90236893 13.3165825,1.90236893 13.7071068,2.29289322 C14.0675907,2.65337718 14.0953203,3.22060824 13.7902954,3.61289944 L13.7071068,3.70710678 L9.415,8 L13.7071068,12.2928932 C14.0976311,12.6834175 14.0976311,13.3165825 13.7071068,13.7071068 C13.3466228,14.0675907 12.7793918,14.0953203 12.3871006,13.7902954 L12.2928932,13.7071068 L8,9.415 L3.70710678,13.7071068 C3.31658249,14.0976311 2.68341751,14.0976311 2.29289322,13.7071068 C1.93240926,13.3466228 1.90467972,12.7793918 2.20970461,12.3871006 L2.29289322,12.2928932 L6.585,8 L2.29289322,3.70710678 C1.90236893,3.31658249 1.90236893,2.68341751 2.29289322,2.29289322 C2.65337718,1.93240926 3.22060824,1.90467972 3.61289944,2.20970461 Z"></path>
    </svg>
  </button>
</template>

<script setup>
  import { Props } from './props.js';
  //----------------------
  const props = defineProps(Props());
</script>

<style scoped lang="scss">
  @import "styles/_base.scss";
</style>
